<template>
  <div id="marathon_videoSectionPlayerIndex" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        :inputObject="select_opt_inputObject"
        :progressObject="select_opt_progressObject"
        @changeSelectEvent="changeSelect"
        @inputValEvent="inputValHandler"
      ></marathon_select_opt>
    </div>
    <div class="teamTable">
      <div class="tableScrollArea" ref="tableParentDom">
        <nodeTree_table
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :tableMode="tableMode"
          :parentWidthPx="parentWidthPx"
          :isScrollFlag="isScrollFlag"
          :variableColWidthVw="variableColWidthVw"
          :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
          :defaultWidthVwNum="defaultWidthVwNum"
          :tableColumnData="tableColumnData"
          :tableData="tableData"
          :tableHeightPx="tableHeightPx"
          @clickColumnEvent="clickColumn"
          :expandKey="expandKey"
          @toParentEvent="toParentEventHandler"
          v-show="tableData && tableData.length > 0"
        ></nodeTree_table>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <p class="noDataClass" v-show="noData">暂无数据</p>
      </div>
    </div>
    <Popup
      v-if="popupShow"
      :closeEvent="closePopup"
      :popTitle="popTitle"
      :popOpraBtns="popOpraBtns"
      :contentWidth="contentWidth"
    >
      <template #webmaster_popup>
        <!-- 编辑时间 -->
        <div class="group_popup" v-if="popState === 'editTime'">
          <div
            class="group_popup_row"
            :class="keyItem.className ? keyItem.className : ''"
            v-for="keyItem in popupObj_keyArr"
            :key="keyItem.key"
          >
            <span v-if="keyItem.isRequest" v-text="`*${keyItem.name}`"></span>
            <span v-else v-text="keyItem.name"></span>
            <div
              class="row_right_item"
              v-if="keyItem.type === 'Text'"
              v-text="popupObjData[keyItem.key]"
            ></div>
            <div class="row_right_item" v-else-if="keyItem.type === 'Time'">
              <el-input-number
                v-model="popupObjData[keyItem.key]"
                :precision="1"
              />
              <span class="ceil" v-text="'秒'"></span>
            </div>
          </div>

          <div class="group_popup_warning" v-show="warningText">
            <span>*</span>
            <span v-text="warningText"></span>
          </div>
        </div>
        <!-- 生产切片 -->
        <div class="group_popup" v-if="popState === 'producing'">
          <!-- <div class="group_popup_delete_tit" v-text="`【${}】`"></div> -->
          <div class="group_popup_delete_wraning">
            您确定生产
            <span v-text="popupDynameVal ? popupDynameVal : ''"></span>
            的切片吗？
          </div>
        </div>
        <!-- 切片视频 -->
        <div class="group_popup" v-if="popState === 'clipVideo'">
          <!-- <div class="group_popup_delete_tit" v-text="`${popupDynameVal}`"></div> -->
          <div class="group_popup_video_box">
            <videoAliplayerV2 :options="{ source: popupObjData.clipObject }" />
          </div>
        </div>
      </template>
    </Popup>
  </div>
</template>

<script>
import {
  https_marathon_playerSectionList,
  https_marathon_videoTemplateList,
  https_marathon_stageteammenu,
  https_marathon_playerClipItemEidtOffset,
  https_marathon_playerClipItemProduction,
  https_marathon_playerItemClip,
  https_marathon_matchTemplateClip,
  https_marathon_matchTemplateClipRate,
} from '@api/platfrom_marathon_api'
import Popup from '@components/base/base_popup.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'

// 表格中不需要跳转页面
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
import videoAliplayerV2 from '@components/base/video_aliplayer_v2.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'marathon_videoSectionPlayerIndex',
  components: {
    marathon_select_opt,
    nodeTree_table,
    Popup,
    videoAliplayerV2,
  },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      select_opt_inputObject: {
        inputTitle: '快速查询',
        placeholder: '请输入运动员名称',
        iconType: 'search',
      }, //控制marathon_select_opt中的输入框是否显示
      select_opt_progressObject: null,
      loading: false,
      isScrollBottom: false,
      tableMode: 'marathonPlayerData',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 18.06,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      expandKey: 'isExpand',
      currStageMarathon: '-1',
      pnum: 1,
      psize: 20,
      marathonTypeArr: [],
      videoTemplateArr: [],
      actArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'marathonType',
            title: '赛事类型',
            origin_keyVal: ['value', 'name'],
            dataName: 'marathonTypeArr',
          },
          {
            type: 'videoTemplate',
            title: '视频模版',
            origin_keyVal: ['value', 'name'],
            dataName: 'videoTemplateArr',
          },
        ],
        selectOpt_list: [],
      },
      contentWidth: '56%',
      popupShow: false,
      popTitle: '添加摄像机位',
      popState: '',
      popupObjData: {},
      popOpraBtns: [],
      warningText: '',
      popupDynameVal: '',
      popupObj_keyArr: [
        {
          name: '运动员：',
          key: 'athleteName',
          isRequest: false,
          isShowText: true,
          type: 'Text',
          ceil: '',
        },
        {
          name: '切片机位：',
          key: 'streamName',
          isRequest: false,
          isShowText: true,
          type: 'Text',
          ceil: '',
        },
        {
          name: '偏移时间',
          key: 'clipOffset',
          isRequest: true,
          isShowText: true,
          type: 'Time',
          ceil: '秒',
        },
      ],
    }
  },
  beforeCreate() {},
  created() {
    // this.parentHeightPx = this.$refs.tableParentDom.offsetHeight
    this.init()
    this.select_opt_progressObject = {
      btnArr: [
        {
          key: 1,
          name: '生产切片',
          clickEvent: this.popupMatchTemplateClipHanlder,
        },
        // {
        //   key: 2,
        //   name: '发布锦集',
        //   clickEvent: () => {},
        // },
      ],
      percentage: 0, //(0-100)
      progressColor: this.currThemeObj.cssStyle.mainColor6,
      currBtnKey: 1, //btnArr中某个元素的key值
    }
  },
  beforeDestroy() {
    this.clearTimeoutProgessHandler()
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  computed: {
    noMore() {
      const curTableDataNum = this.tableData ? this.tableData.length : -1
      return (
        curTableDataNum >= this.tableTotal &&
        this.tableTotal !== 0 &&
        this.isScrollBottom
      )
    },
    noData() {
      return (
        this.tableTotal === 0 && this.tableData && this.tableData.length === 0
      )
    },
    tableHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375

      return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      // return 500
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.initTableQuery()
      console.debug(this.currCid, this.currSid)
      await this.getstageMarathon()
      await this.getVideoTemplate()
      await this.getMatchTemplateClipRate()
      this.setTimeoutProgessHandler()
      await this.getPlayerSectionList()
      console.debug(this.stageArr)
      this.computedSelectOpt(this.selectOptData.configArr)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    // 关闭弹窗
    closePopup() {
      this.popupShow = false
      this.popupObjData = {}
      this.warningText = ''
      this.contentWidth = '56%'
    },
    toParentEventHandler(data) {
      console.debug(data)
      if (data.eventName === 'marathonPlayerData_editTime') {
        // 单个机位的编辑时间
        this.popupEidtTimeHanlder(data)
      } else if (data.eventName === 'marathonPlayerData_singleCameraSection') {
        // 单个机位的生产切片
        this.popupCameraItemClipHanlder(data)
      } else if (data.eventName === 'marathonPlayerData_singlePlayerSection') {
        // 单个运动员的生产切片
        this.popupPlayerItemClipHanlder(data)
      } else if (data.eventName === 'marathonPlayerData_singleClipVideo') {
        // 查看单个切片的视频
        this.popupClipVideoHanlder(data)
      }
    },
    popupClipVideoHanlder(item) {
      console.debug(item)
      this.contentWidth = '48%'
      this.popupObjData = item.data
      this.popOpraBtns = []
      this.popState = 'clipVideo'
      this.popTitle = `【${item.athleteName}】【${this.popupObjData.streamName}】切片视频`
      this.popupShow = true
    },
    popupEidtTimeHanlder(item) {
      console.debug(item)
      let popupObjData = item.data
      popupObjData.athleteName = item.athleteName
      popupObjData.athleteNum = item.athleteNum
      this.popupObjData = popupObjData
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '保存',
          btnEvent: this.postPlayerClipItemEidtOffset,
          btnStyle: '',
        },
      ]
      this.popState = 'editTime'
      this.popTitle = '编辑时间'
      this.popupShow = true
    },
    popupCameraItemClipHanlder(item) {
      let popupObjData = item.data
      popupObjData.athleteName = item.athleteName
      popupObjData.athleteNum = item.athleteNum
      this.popupObjData = popupObjData
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '确定',
          btnEvent: this.postPlayerClipItemProduction,
          btnStyle: '',
        },
      ]
      this.popupDynameVal = `【${this.popupObjData.athleteName}】【${this.popupObjData.streamName}】`
      this.popState = 'producing'
      this.popTitle = '生产切片'
      this.popupShow = true
    },
    popupPlayerItemClipHanlder(item) {
      this.popupObjData = item.data
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '确定',
          btnEvent: this.postPlayerItemClip,
          btnStyle: '',
        },
      ]
      this.popupDynameVal = `【${this.popupObjData.athleteName}】`
      this.popState = 'producing'
      this.popTitle = '生产切片'
      this.popupShow = true
    },
    popupMatchTemplateClipHanlder() {
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '确定',
          btnEvent: this.postMatchTemplateClip,
          btnStyle: '',
        },
      ]
      this.popupDynameVal = `【当前所有运动员】`
      this.popState = 'producing'
      this.popTitle = '生产切片'
      this.popupShow = true
    },
    async postPlayerClipItemEidtOffset() {
      const item = this.popupObjData
      console.debug('item:', item)
      let params = {
        matchId: this.currSid,
        tplId: this.currVideoMode,
        athleteNum: item.athleteNum,
        postData: {
          paramKey: item.paramKey,
          clipOffset: item.clipOffset + '',
        },
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      if (typeof item.clipOffset !== 'number') {
        this.warningText = '偏移时间的值不是数字'
        return
      }
      console.debug(item.clipOffset, typeof item.clipOffset)
      await https_marathon_playerClipItemEidtOffset(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('保存成功')
            this.$message({
              showClose: true,
              message: '保存成功',
              type: 'success',
            })
            this.closePopup()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async postPlayerClipItemProduction() {
      const item = this.popupObjData
      let params = {
        matchId: this.currSid,
        tplId: this.currVideoMode,
        athleteNum: item.athleteNum,
        postData: {
          paramKey: item.paramKey,
        },
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_playerClipItemProduction(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('已提交，正在生产中，稍后查看')
            this.$message({
              showClose: true,
              message: '已提交，正在生产中，稍后查看',
              type: 'success',
            })
            this.closePopup()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async postPlayerItemClip() {
      const item = this.popupObjData
      let params = {
        matchId: this.currSid,
        tplId: this.currVideoMode,
        athleteNum: item.athleteNum,
      }

      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_playerItemClip(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('已提交，正在生产中，稍后查看')
            this.$message({
              showClose: true,
              message: '已提交，正在生产中，稍后查看',
              type: 'success',
            })
            this.closePopup()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async postMatchTemplateClip() {
      let params = {
        matchId: this.currSid,
        tplId: this.currVideoMode,
        postData: {
          code: this.currStageMarathon,
        },
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_matchTemplateClip(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('已提交，正在生产中，稍后查看')
            this.$message({
              showClose: true,
              message: '已提交，正在生产中，稍后查看',
              type: 'success',
            })
            this.closePopup()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async getMatchTemplateClipRate() {
      let params = {
        matchId: this.currSid,
        tplId: this.currVideoMode,
        code: this.currStageMarathon,
      }
      let rate = this.select_opt_progressObject.percentage
      await https_marathon_matchTemplateClipRate(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          if (response) {
            const res = response.data
            if (res.status === 0) {
              console.debug(res)
              rate =
                res.data.rate == 1 ? 100 : (res.data.rate * 100).toFixed(2) * 1
              let select_opt_progressObject = this.select_opt_progressObject
              select_opt_progressObject.percentage = rate
              this.select_opt_progressObject = select_opt_progressObject
            }
          }
        })
        .catch((err) => {
          console.debug(err)
          if (err.message) {
            // message：null，因此不弹出警示框（一般404 || 500的时候）；
            // message不为null的时候展示警示框；
            this.$message({
              showClose: true,
              message: err.message ? err.message : '服务器异常，请稍后再试',
              type: 'warning',
            })
          }
        })
      if (this.setTimeoutId) {
        this.setTimeoutProgessHandler()
      }
    },
    setTimeoutProgessHandler() {
      this.setTimeoutId = window.setTimeout(() => {
        this.getMatchTemplateClipRate()
      }, 10 * 1000)
    },
    clearTimeoutProgessHandler() {
      if (this.setTimeoutId) {
        window.clearTimeout(this.setTimeoutId)
        this.setTimeoutId = null
      }
    },
    inputValHandler(inputVal) {
      // 获取inputVal值
      console.debug('inputVal:', inputVal)
      this.curInputVal = inputVal
      this.initTableQuery()
      this.getPlayerSectionList()
    },
    initScroll() {
      if (this.tableDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      console.debug(
        'this.parentWidthPx:',
        this.$refs.tableParentDom.scrollHeight
      )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })
      this.tableDom = document.getElementsByClassName(
        'el-table__body-wrapper'
      )[0]
      this.tableDom.addEventListener('scroll', () => {
        const scrollTop = this.tableDom.scrollTop
        const scrollHeight = this.tableDom.scrollHeight
        const parentHeightPx = this.tableDom.offsetHeight
        let direction = this.DIRECTION_ENUM.DOWN
        if (this.beforeScrollTop > scrollTop) {
          direction = this.DIRECTION_ENUM.UP
        }
        // 通过滚动方向判断是触底还是触顶
        console.debug(
          'direction:',
          direction,
          scrollTop,
          parentHeightPx,
          scrollHeight,
          this.isScrollBottom
        )
        if (direction == this.DIRECTION_ENUM.DOWN) {
          // 滚动触底
          if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
            console.debug('滚动触底')
            this.load()
            if (this.pnum > this.allPages) {
              this.isScrollBottom = true
            }
          }
        } else {
          // 滚动到顶部
          this.isScrollBottom = false
          if (scrollTop <= this.threshold) {
            console.debug('滚动到顶部')
          }
        }
        this.beforeScrollTop = this.tableDom.scrollTop
      })
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedSelectOpt(configArr, type) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        console.debug(config.dataName, this[config.dataName])
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        if (type) {
          selectOpt_list = this.selectOptData.selectOpt_list
          if (config.type === type) {
            selectOpt_list.forEach((item) => {
              if (item.type === type) {
                item.list = list
                item.curId = list[0] ? list[0][mix_id] : ''
                item.curVal = list[0] ? list[0][config.origin_keyVal[1]] : ''
              }
            })
          }
        } else {
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[0] ? list[0][mix_id] : '', // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[0] ? list[0][config.origin_keyVal[1]] : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    async changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'marathonType') {
            this.currStageMarathon = valPathArr[1]
            await this.getVideoTemplate()
            this.computedSelectOpt(
              this.selectOptData.configArr,
              'videoTemplate'
            )
            // console.debug(this.selectOptData.selectOpt_list)
          } else if (valPathArr[0] === 'videoTemplate') {
            this.currVideoMode = valPathArr[1]
          } else {
          }
          // 筛选表格逻辑
          this.initTableQuery()
          this.tableColumnData = []
          this.clearTimeoutProgessHandler()
          await this.getMatchTemplateClipRate()
          this.setTimeoutProgessHandler()
          await this.getPlayerSectionList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    load() {
      console.debug('load')
      if (this.pnum > this.allPages || this.loading) {
        return
      }
      this.loading = true
      this.getPlayerSectionList()
    },
    clickColumn(prop) {
      console.debug(prop)
      this.initTableQuery()
      this.getPlayerSectionList()
    },
    initTableQuery() {
      this.pnum = 1
    },
    async getstageMarathon() {
      await https_marathon_stageteammenu(this.axiosBaseUrl, this.$axios)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.marathonTypeArr = res.data ? res.data : []
            this.currStageMarathon = res.data[0] ? res.data[0].value : ''
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getVideoTemplate() {
      let params = {
        matchId: this.currSid,
        code: this.currStageMarathon,
      }
      await https_marathon_videoTemplateList(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.videoTemplateArr = res.data
              ? res.data.map((item) => {
                  return {
                    value: item.templateId,
                    name: item.templateName,
                  }
                })
              : []
            if (this.videoTemplateArr.length > 0) {
              this.currVideoMode = this.videoTemplateArr[0].value
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getPlayerSectionList() {
      await https_marathon_playerSectionList(this.axiosBaseUrl, this.$axios, {
        matchId: this.currSid,
        tplId: this.currVideoMode ? this.currVideoMode : '',
        code: this.currStageMarathon ? this.currStageMarathon : '',
        athleteName: this.curInputVal ? this.curInputVal : '',
        page: this.pnum,
        pageSize: this.psize,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data) {
              this.tableTotal = res.data.total
              this.allPages = res.data.pageSize
              const columns = [
                {
                  colKey: 'rankNum',
                  colTitle: '排名',
                },
                {
                  colKey: 'athleteName',
                  colTitle: '球员名称',
                },
                {
                  colKey: 'playerLogo',
                  colTitle: '球员头像',
                },
                {
                  colKey: 'gunTime',
                  colTitle: '枪时成绩',
                },
                {
                  colKey: 'netTime',
                  colTitle: '净成绩',
                },
                {
                  colKey: 'avgPace',
                  colTitle: '平均配速(min/km)',
                },
                {
                  colKey: 'avgSpeed',
                  colTitle: '平均时速(km/h)',
                },
                {
                  colKey: 'operateArr',
                  colTitle: '操作',
                },
                {
                  colKey: 'isExpand',
                  colTitle: '',
                },
              ]
              const fristColumns = columns.slice(0, 3)
              const otherColumns = columns.slice(3)
              this.defaultWidthVwNum = otherColumns.length - 1 //减去这一列isExpand
              if (this.tableColumnData.length == 0) {
                let tableColumnData = []
                let fristColumnPropArr = []
                for (let i = 0; i < fristColumns.length; i++) {
                  fristColumnPropArr.push(fristColumns[i].colKey)
                }
                const fristColumn = {
                  prop: 'rankNum-playerLogo-playerName-shirtNumber-sex', //fristColumnPropArr.join('-'),
                  label: '运动员',
                  widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                  className: 'columnNumLogoNameClass', //单独定制的头部样式class
                  // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                }

                tableColumnData.push(fristColumn)
                for (let i = 0; i < otherColumns.length; i++) {
                  const item = otherColumns[i]
                  tableColumnData.push({
                    prop: item.colKey,
                    label: item.colTitle,
                    widthVw:
                      item.colKey != 'isExpand'
                        ? this.tableCellDefaultWidthVw
                        : 2.778, //单独设置 isExpand 的对应列的宽度，单位vw
                    className:
                      item.colKey != 'isExpand' ? '' : 'columnLogoNameClass', //单独定制的头部样式class
                    selected: '',
                  })
                }
                // console.debug('res.data：',res.data)
                this.tableColumnData = tableColumnData
              }
              if (this.pnum == 1) {
                this.tableData = res.data.datas
                  ? res.data.datas.map((val) => {
                      this.actArr.forEach((item) => {
                        if (item.code == val.isActive) {
                          val.isActiveName = item.name
                        }
                      })
                      val.rankNum = ''
                      val.genderName = val.gender
                      val.playerLogo = val.profilePicture
                      val.isExpand = val.infos
                        ? val.infos.map((info, infoIndex) => {
                            return {
                              id: infoIndex + 1,
                              streamName: info.streamName
                                ? info.streamName
                                : '',
                              clipObject: info.clipObject
                                ? info.clipObject
                                : '',
                              clipOffset: info.clipOffset ? info.clipOffset : 0,
                              paramKey: info.paramKey,
                            }
                          })
                        : []
                      return val
                    })
                  : // [
                    //   {
                    //     rankNum: 1,
                    //     playerName: 'asdsad',
                    //     playerLogo: '',
                    //     gunHourResults: '01:09:31',
                    //     netAchievement: '01:08:35',
                    //     averagePace: '03:15',
                    //     averageSpeed: '18.46',
                    //     sex: '男',
                    //     shirtNumber: 'FOO8',
                    //     isExpand: [
                    //       {
                    //         id: 1,
                    //         jiwei: '出发点',
                    //         qiepian: 'asdasdsa',
                    //         miao: '2',
                    //       },
                    //       {
                    //         id: 2,
                    //         jiwei: '5KM',
                    //         qiepian: 'asdasdsa',
                    //         miao: '2',
                    //       },
                    //       {
                    //         id: 3,
                    //         jiwei: '10KM',
                    //         qiepian: 'asdasdsa',
                    //         miao: '2',
                    //       },
                    //     ],
                    //   },
                    //   {
                    //     rankNum: 2,
                    //     playerName: 'asdsad',
                    //     playerLogo: '',
                    //     gunHourResults: '01:09:31',
                    //     netAchievement: '01:08:35',
                    //     averagePace: '03:15',
                    //     averageSpeed: '18.46',
                    //     sex: '男',
                    //     shirtNumber: 'FOO9',
                    //     isExpand: [
                    //       {
                    //         id: 1,
                    //         jiwei: '出发点1',
                    //         qiepian: 'asdasdsa',
                    //         miao: '2',
                    //       },
                    //       {
                    //         id: 2,
                    //         jiwei: '5KM1',
                    //         qiepian: 'asdasdsa',
                    //         miao: '2',
                    //       },
                    //       {
                    //         id: 3,
                    //         jiwei: '10KM2',
                    //         qiepian: 'asdasdsa',
                    //         miao: '2',
                    //       },
                    //     ],
                    //   },
                    // ]
                    []
                // this.$refs.tableParentDom.scrollTo(0, 0)
                this.initScroll()
              } else {
                let indexNo =
                  this.tableData && this.tableData.length > 0
                    ? this.tableData.length
                    : 0
                this.tableData = this.tableData.concat(
                  res.data
                    ? res.data.datas.map((val) => {
                        this.actArr.forEach((item) => {
                          if (item.code == val.isActive) {
                            val.isActiveName = item.name
                          }
                        })
                        val.rankNum = ''
                        val.genderName = val.gender
                        val.playerLogo = val.profilePicture
                        val.isExpand = val.infos
                          ? val.infos.map((info, infoIndex) => {
                              return {
                                id: infoIndex + 1,
                                streamName: info.streamName
                                  ? info.streamName
                                  : '',
                                clipObject: info.clipObject
                                  ? info.clipObject
                                  : '',
                                clipOffset: info.clipOffset
                                  ? info.clipOffset
                                  : 0,
                                paramKey: info.paramKey,
                              }
                            })
                          : []
                        return val
                      })
                    : []
                )
              }
            } else {
              console.debug('暂无数据')
            }
            console.debug(
              '暂无数据:',
              this.tableTotal,
              this.tableData,
              this.tableData.length
            )
            if (this.tableTotal >= this.tableData.length) {
              if (this.tableTotal === 0) {
                this.tableData = []
              } else {
                if (this.pnum !== 1) {
                  this.$nextTick(() => {
                    this.loading = false
                  })
                } else {
                  this.$nextTick(() => {
                    this.loading = false
                    if (
                      this.$refs.tableParentDom.offsetHeight <
                      Math.floor(this.tableHeightPx)
                    ) {
                      this.isScrollBottom = true
                    }
                    console.debug(
                      'getParentHeightPx:',
                      this.$refs.tableParentDom.offsetHeight,
                      this.tableHeightPx
                    )
                  })
                }
                this.pnum++
              }
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#marathon_videoSectionPlayerIndex {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 2.778vw 0 6.964vw;
    .tableScrollArea {
      position: relative;
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }

  .group_popup {
    height: 100%;
    padding: 0.694vw;
    width: 90%;
    h1 {
      font-size: 1.25vw;
      color: var(--mixtmt_greyColor3);
    }
    .group_popup_row {
      margin-bottom: 1.388vw;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      &.alignItemsStart {
        align-items: flex-start;
      }
      .row_right_item {
        flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        &.flexColumn {
          flex-direction: column;
          align-items: flex-start;
        }
        .ceil {
          padding-left: 0.694vw;
          font-size: 0.972vw;
          font-weight: 600;
          color: var(--mixtmt_greyColor2);
        }
      }
      & > span {
        width: 8.333vw;
        padding-right: 0.694vw;
        text-align: right;
        font-size: 0.972vw;
        font-weight: 600;
        color: var(--mixtmt_greyColor2);
      }
    }
    .group_popup_warning {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 1.25vw;
      font-size: 0.8333vw;
      font-weight: 400;
      color: var(--mixtmt_errColor);
      line-height: 1.25vw;
      margin: 0.694vw 0;
    }
    .group_popup_btns {
      text-align: center;
      &:after {
        content: '';
        clear: both;
      }
    }
    .group_popup_cancel,
    .group_popup_save {
      display: inline-block;
      width: 8.333vw;
      height: 1.94vw;
      background: rgba(255, 255, 255, 1);
      border-radius: 0.138vw;
      border: 1px solid rgba(220, 223, 230, 1);
      font-size: 0.833vw;
      font-weight: 500;
      color: rgba(90, 94, 102, 1);
      line-height: 1.94vw;
      cursor: pointer;
    }
    .group_popup_save {
      margin-left: 1.388vw;
      background: var(--mixtmt_mainColor6);
      color: rgba(255, 255, 255, 1);
      border: none;
      &:hover {
        background: var(--mixtmt_mainColor6);
      }
    }
    .group_popup_cancel {
      &:hover {
        border: 1px solid var(--mixtmt_mainColor6);
      }
    }
    // 删除弹框样式
    .group_popup_delete_tit {
      font-size: 0.972vw;
      font-weight: 600;
      color: var(--mixtmt_greyColor2);
      line-height: 1.25vw;
      text-align: center;
    }
    .group_popup_delete_wraning {
      margin: 1.388vw 0;
      font-size: 0.972vw;
      font-weight: 600;
      color: var(--mixtmt_greyColor2);
      line-height: 1.667vw;
      text-align: center;
      span {
        color: var(--mixtmt_errColor);
      }
    }
    .group_popup_video_box {
      position: relative;
      width: 100%;
      height: calc(60vh - 8.333vw - 2.778vw);
    }
  }
}
</style>
